module.exports = __webpack_public_path__ + "static/media/dental-crown.66e130d0.svg";